import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'

import { getUserTaxProfile } from '@flecto/api/shared'

export function useQueryGetUserTaxProfile() {
  const router = useRouter()
  const isFlectoLink = router.asPath.startsWith('/b_') ?? false

  return useQuery({
    queryKey: ['QueryGetUserTaxProfile'],
    queryFn: async () => await getUserTaxProfile(),
    refetchOnWindowFocus: false,
    enabled: !isFlectoLink,
  })
}
